import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import Summary from '../Summary'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const debug = !!window.location.hostname.match('localhost')
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
    debug ? 'debug' : '',
  ]

  const theme = {
    colorMode: colorMode,
    textColor: colorMode === 'dark' ? '#E9E9E9' : '#202346',
    plainColor: colorMode === 'dark' ? '#121212' : '#efefef',
  }
  const locale = tenant?.lang ? tenant?.lang : 'fr'

  return (
    <AppContainer className={globalClasses.join(' ')} theme={theme}>
      <TextWidth>
        <Summary
          colorMode={colorMode || 'dark'}
          locale={locale}
          hideCharts={properties?.hideCharts}
        />
      </TextWidth>
    </AppContainer>
  )
}

const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  padding-bottom: 2em;
  &.debug {
    background-color: ${(props) => props.theme.plainColor}; // Only on localhost
  }
`
export default MainComponent
